// exports
export const MEDIA_QUERIES = { MD: 1200, SM: 600, XS: 460 };

export const KYB_STEPS = { ONE: "ONE", TWO: "TWO", THREE: "THREE", FOUR: "FOUR" };
export const KYB_BACKS = {
  BACK_TO_ONE: "ONE",
  BACK_TO_TWO: "TWO",
  BACK_TO_THREE: "THREE",
};
